import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, exhaustMap, tap, take, Observable, of, map } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { LoaderService } from "./loader.service";
import { ActionResult, UserDetail } from "@model";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class UserDetailService {
  private static _currentUserDetails = new BehaviorSubject<UserDetail | undefined>(undefined);

  get currentUserDetails() {
    return UserDetailService._currentUserDetails;
  }

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    private loaderService: LoaderService,
    private environmentService: EnvironmentService
  ) {}

  fetchUserProfile(onSuccess?: (userDetails: UserDetail | undefined) => void): void {
    this.http.post<ActionResult<UserDetail>>(this.environmentService.getApiUrl() + "/api/user/userprofile", {}).subscribe(actionResult => {
      this.currentUserDetails.next(actionResult.result);
      this.fetchUserProfileWithImage();
      if (onSuccess) {
        onSuccess(actionResult.result)
      }
    });
  }

  private fetchUserProfileWithImage(): void {
    this.http.post<ActionResult<UserDetail>>(this.environmentService.getApiUrl() + "/api/user/userprofile/withImage", {}).subscribe(actionResult => {
      this.currentUserDetails.next(actionResult.result);
    });
  }

  fetchCurrentUserDetails(): Observable<UserDetail | undefined> {
    return this.currentUserDetails.value ? of(this.currentUserDetails.value) : this.http.post<ActionResult<UserDetail>>(this.environmentService.getApiUrl() + "/api/user/userprofile", {}).pipe(
      map(actionResult => {
        this.fetchUserProfileWithImage();
        const result = actionResult.result ?? undefined;
        this.currentUserDetails.next(result);
        return result;
      })
    );
  }

  updateUserProfile(userDetails: UserDetail, onSuccess: () => void): void {
    this.loaderService.startLoading();
    this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + "/api/user/userprofile/update", userDetails).pipe(
      tap(() => this.loaderService.dismissLoading()),
    ).subscribe(actionResult => {
      if (actionResult.resultCode !== -1) {
        this.currentUserDetails.next(userDetails);
        onSuccess();
        this.fetchUserProfileWithImage();
      }
    });
  }

  emptyCurrentUserDetails(): void {
    this.currentUserDetails.next(undefined);
  }
}
